import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import { alterarStatusSegregacao } from '../api/SegregacaoApi';
import type { SegregacaoAlterarStatusPayload } from '../api/types';

export function useAlterarStatusSegregacao() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (payload: SegregacaoAlterarStatusPayload) => alterarStatusSegregacao(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['segregacao-calcular'] });
      toast({ title: 'Produto marcado como revisado com sucesso.' });
    },
    onError: () => {
      toast({
        variant: 'destructive',
        title: 'Erro ao alterar status',
        description: 'Não foi possível completar a operação. Tente novamente.',
      });
    },
  });
}
